import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import ReactGA from 'react-ga4';

const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const ExternalLinkIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>;

const ContactForm = () => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await addDoc(collection(db, 'contacts'), { name, email, message, timestamp: new Date() });
      setStatus('success');
      ReactGA.event({ category: 'Contact Form', action: 'Submit', label: 'Demo Request' });
      setName(''); setEmail(''); setMessage('');
    } catch (error) {
      console.error("Error adding document: ", error);
      setStatus('error');
    }
  };

  return (
    // A ÚNICA ALTERAÇÃO É AQUI: Adicionando 'overflow-hidden'
    <section id="contact" className="py-20 bg-gradient-to-br from-primary to-secondary overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          <div data-aos="fade-right">
            <h2 className="text-4xl font-bold text-white mb-4">{t('contact_title')}</h2>
            <p className="text-lg text-gray-300 mb-8">{t('contact_subtitle')}</p>
            <ul className="space-y-4">
              <li className="flex items-start"><CheckIcon /><span className="ml-3 text-gray-300">{t('contact_benefit1')}</span></li>
              <li className="flex items-start"><CheckIcon /><span className="ml-3 text-gray-300">{t('contact_benefit2')}</span></li>
              <li className="flex items-start"><CheckIcon /><span className="ml-3 text-gray-300">{t('contact_benefit3')}</span></li>
            </ul>
          </div>

          <div className="bg-white/10 backdrop-blur-lg p-8 rounded-xl border border-white/20" data-aos="fade-left">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="text-white text-sm font-bold mb-2 block">{t('form_name')}</label>
                <input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} className="w-full px-4 py-3 bg-secondary text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-accent" required />
              </div>
              <div>
                <label htmlFor="email" className="text-white text-sm font-bold mb-2 block">{t('form_email')}</label>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3 bg-secondary text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-accent" required />
              </div>
              <div>
                <label htmlFor="message" className="text-white text-sm font-bold mb-2 block">{t('form_message')}</label>
                <textarea id="message" value={message} onChange={(e) => setMessage(e.target.value)} rows="4" className="w-full px-4 py-3 bg-secondary text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-accent" required></textarea>
              </div>
              <button type="submit" className="w-full bg-accent hover:bg-white text-primary font-bold py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-105">
                {t('form_submit')}
              </button>
              {status === 'success' && <p className="mt-4 text-green-400 text-center">{t('form_success')}</p>}
              {status === 'error' && <p className="mt-4 text-red-500 text-center">{t('form_error')}</p>}
            </form>
          </div>
        </div>
        
        <div className="mt-24 text-center" data-aos="fade-up" data-aos-delay="300">
            <p className="text-gray-400 text-sm">{t('contact_powered_by')}</p>
            <a href="https://www.jbkr.com.br" target="_blank" rel="noopener noreferrer" className="text-3xl font-bold text-white hover:text-accent transition-colors">JBKR Web</a>
            <p className="text-gray-400 max-w-2xl mx-auto mt-4">{t('contact_jbkr_desc')}</p>
            <a href="https://www.behance.net/jeancrb" target="_blank" rel="noopener noreferrer" 
               className="inline-flex items-center mt-6 text-accent font-semibold border border-accent/50 py-2 px-5 rounded-full hover:bg-accent hover:text-primary transition-colors">
                {t('contact_jbkr_link')}
                <ExternalLinkIcon />
            </a>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;